<template>
    <form id="onboarding-de" class="wrapper wrapper-tab-last" role="form" method="post" @submit.prevent="submit()">
        <header class="text-centered">
            <figure>
                <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="70" height="70" rx="35" fill="#54DBA3"/>
                <path d="M28.1823 44.408L52.2448 20.3455C52.6904 19.8999 53.2251 19.6771 53.849 19.6771C54.4728 19.6771 55.0298 19.8999 55.52 20.3455C55.9656 20.7911 56.1884 21.3481 56.1884 22.0165C56.1884 22.6403 55.9656 23.1751 55.52 23.6207L29.7865 49.3542C29.3409 49.7998 28.8061 50.0226 28.1823 50.0226C27.5584 50.0226 27.0237 49.7998 26.5781 49.3542L14.4132 37.1892C13.9676 36.7436 13.7448 36.2089 13.7448 35.5851C13.7894 34.9167 14.0344 34.3597 14.48 33.9141C14.9256 33.4685 15.4604 33.2457 16.0842 33.2457C16.7526 33.2457 17.3096 33.4685 17.7552 33.9141L28.1823 44.408Z" fill="white"/>
                </svg>
            </figure>

            <span class="new-headline-xlg">L'iscrizione al programma Vitadio è avvenuta con successo</span>
            <p class="new-text-lg text-color-default">Un codice di attivazione Vitadio di 6 cifre è stato inviato alla tua e-mail e tramite SMS. Controlla anche la cartella spam nel caso in cui tu non abbia trovato il codice di attivazione nella casella di posta</p>
        </header>

        <v-button href="/" label="Grazie mille" size="lg" position="center"></v-button>
    </form>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true,
            }
        },

        methods: {
        }
    }
</script>